import React from "react";

export const LazyDealsPage = React.lazy(() => import("modules/investorRole/pages/DealsPage"));
